import { Badge } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

function BasicQueueTabs({ queueTabs, queueStatus, setQueueStatus }) {
  return (
    <MDBox margin=".8rem 0">
      <MDButton
        variant={queueStatus === "" ? "gradient" : "outlined"}
        color="info"
        size="small"
        onClick={() => {
          setQueueStatus("");
        }}
      >
        Not In Queue{" "}
        <Badge
          color="info"
          sx={{ marginLeft: "1rem" }}
          badgeContent={queueTabs[0].count.toString()}
        />
      </MDButton>
      <MDButton
        sx={{ ml: 1 }}
        variant={queueStatus === "NEW" ? "gradient" : "outlined"}
        color="info"
        size="small"
        onClick={() => {
          setQueueStatus("NEW");
        }}
      >
        In Queue{" "}
        <Badge
          color="info"
          sx={{ marginLeft: "1rem" }}
          badgeContent={queueTabs[1].count.toString()}
        />
      </MDButton>
      <MDButton
        sx={{ ml: 1 }}
        variant={queueStatus === "FAILED" ? "gradient" : "outlined"}
        color="info"
        size="small"
        onClick={() => {
          setQueueStatus("FAILED");
        }}
      >
        Failed{" "}
        <Badge
          color="info"
          sx={{ marginLeft: "1rem" }}
          badgeContent={queueTabs[2].count.toString()}
        />
      </MDButton>
    </MDBox>
  );
}

export default BasicQueueTabs;
